/** What a room runs when somebody enters it. Mirrors the API's `RoomPractice`. */
export enum RoomPractice {
    Timer = 'timer',
    Content = 'content',
    Board = 'board',
}

export const ROOM_PRACTICE_LABELS: Record<RoomPractice, string> = {
    [RoomPractice.Timer]: 'Silent timer (Vipassana)',
    [RoomPractice.Content]: 'Guided content',
    [RoomPractice.Board]: 'Standing board',
};

/** The marks the app can draw for a room. Drawn in the client, so no upload. */
export const ROOM_ART_KEYS = ['candle', 'waves', 'board', 'bell', 'lotus'] as const;

interface MeditationRoom {
    id: string;
    /**
     * PERMANENT. Every attendance row points at this, so changing it orphans
     * every sit ever recorded here — the room would report zero and every
     * member's rank would reset, with nothing logged. The API refuses to update
     * it; rename `name` instead.
     */
    key: string;
    name: string;
    tagline?: string;
    practice: RoomPractice;
    categoryId?: string;
    artKey: string;
    orderIndex: number;
    active: boolean;
    created_at: string;
    updated_at: string;
    deleted?: boolean;
}

export default MeditationRoom;
